import React, { Component } from 'react'

const CAPTURE_OPTIONS = {
    audio: false,
    video: { facingMode: "environment" }
};

class Camera extends Component {
  constructor(props){
    super(props)
    this.state = {
        stream: null,
        picture: null
    }
    this.video = null;
    this.containerVideo = null;
    this.canvas = null;
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleCanPlay = this.handleCanPlay.bind(this);
    this.onCapture = this.onCapture.bind(this);
    this.handleCapture = this.handleCapture.bind(this);
    this.onClear = this.onClear.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  componentDidMount(){
    navigator.mediaDevices
    .getUserMedia(CAPTURE_OPTIONS)
    .then(stream => {
        this.setState({...this.state, stream: stream})
    });
  }

  componentDidUnMount(){
    this.state.stream.getTracks().forEach(track => {
        track.stop();
    });
  }

  handleOnChange(event){
    event.preventDefault()
    if(this.props.onChange){
      this.props.onChange(this.state.picture);
    }
  }

  handleCapture(event) {
    event.preventDefault()
    const context = this.canvas.getContext('2d');
    context.drawImage(this.video,0, 0, 640, 480);
    this.canvas.toBlob(blob => this.onCapture(blob), "image/jpeg", 1);
  }

  onCapture(blob) {
    this.setState({...this.state, picture: blob});
  }

  handleClear() {
    const context = this.canvas.getContext("2d");
    context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.onClear();
  }

  onClear(blob) {
    this.setState({...this.state, picture: undefined});
  }


  handleCanPlay() {
    this.video.play();
  }

  calculateOffset(videoContainer, video){
    if (video && videoContainer){
        return {
            x: video.width > videoContainer.width ?  Math.round((video.width - videoContainer.width) / 2) : 0,
            y: video.height > videoContainer.height ?  Math.round((video.height - videoContainer.height) / 2) : 0,
        }
    }
  }

  render() {
    if (this.state.stream && this.video && !this.video.srcObject) {
        this.video.srcObject = this.state.stream;
    }

    const videoOffset = this.calculateOffset(this.containerVideo, this.video);
    const ConfirmButtons = (<div>
                              <button onClick={this.handleOnChange}> Aceptar </button>
                              <button onClick={this.handleClear}> Rechazar </button>
                            </div>);
    const shownButtons = this.state.picture ? ConfirmButtons :  (<button onClick={this.handleCapture}> Tomar Foto </button>)
                  
    const ImagePreview = (this.state.picture ? <img src={URL.createObjectURL(this.state.picture)}/> : '');
    return (
      <div>
        <div 
          ref={(component) => {this.containerVideo = component}}
          style={{position: 'relative'}}>
            <video 
              ref={(component) => { this.video = component }}
              onPlay={this.handleCanPlay}
              style={{top: `-${(videoOffset ? videoOffset.y : 0)}px`, left: `-${videoOffset ? videoOffset.x : 0}px` }}
              hidden={this.state.picture ? true : false}
              autoPlay
              playsInline
              muted
            />
            <canvas
                ref={(component) => {this.canvas = component}}
                style={{position: 'absolute'}}
            />
        </div>
        {ImagePreview}
        {shownButtons}
      </div>
    );
  }
}
module.exports = Camera


/** WEBPACK FOOTER **
 ** ./src/components/Camera.js
 **/